import {
  CDT_BACKEND_URL,
  CN_MGMT_API_URL,
  PARTNER_MGMT_API_URL,
  TASK_VIEWER_BACKEND_API_URL,
} from 'services/constants';
import axios from 'axios';
import { UserAuthorityDTO } from 'types/User';
import { getHostBaseUrl } from 'utils/browserUtil';

const axiosInstance = axios.create({ baseURL: getHostBaseUrl(), withCredentials: true });

/**
 * Fetch the list of authorities for different applications.
 */

const getPartnerAuthorities = async () => {
  try {
    const response = await axiosInstance.get(`${PARTNER_MGMT_API_URL}/user-authorities/read`);
    return response.data;
  } catch (e) {
    return { ...[], authorityList: [] };
  }
};

const getNoteAuthorities = async () => {
  try {
    const response = await axiosInstance.get(`${CN_MGMT_API_URL}/user-authorities/read`);
    return response.data;
  } catch (e) {
    return { ...[], authorityList: [] };
  }
};

const getTaskManagerAuthorities = async () => {
  try {
    const response = await axiosInstance.get(`${TASK_VIEWER_BACKEND_API_URL}/user-authorities/read`);
    return response.data;
  } catch (e) {
    return { ...[], authorityList: [] };
  }
};

const getDistributionCenterAuthorities = async () => {
  try {
    const response = await axiosInstance.get(`${CDT_BACKEND_URL}/api/user-authorities/read`);
    return response.data;
  } catch (e) {
    return { ...[], authorityList: [] };
  }
};

export const fetchUserAuthorities = async (): Promise<UserAuthorityDTO> => {
  const userAuthorities: UserAuthorityDTO = {
    partner: [],
    note: [],
    taskManager: [],
    distributionCenter: [],
  };

  try {
    const partnerAuthorities = await getPartnerAuthorities();
    userAuthorities.partner = partnerAuthorities.authorityList;
  } catch (error) {
    userAuthorities.partner = [];
  }

  try {
    const noteAuthorities = await getNoteAuthorities();
    userAuthorities.note = noteAuthorities.authorityList;
  } catch (error) {
    userAuthorities.note = [];
  }

  try {
    const taskManagerAuthorities = await getTaskManagerAuthorities();
    userAuthorities.taskManager = taskManagerAuthorities.authorityList;
  } catch (error) {
    userAuthorities.taskManager = [];
  }

  try {
    const distributionCenterAuthorities = await getDistributionCenterAuthorities();
    userAuthorities.distributionCenter = distributionCenterAuthorities.authorityList;
  } catch (error) {
    userAuthorities.distributionCenter = [];
  }

  return userAuthorities;
};

const authorityService = { getPartnerAuthorities, getNoteAuthorities, fetchUserAuthorities };
export default authorityService;
